var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"progress",style:(_vm.wrapStyle)},[_c('div',{class:_vm.css,style:(_vm.barStyle),attrs:{"role":"progressbar","aria-valuenow":_vm.value,"aria-valuemin":"0","aria-valuemax":"100"},domProps:{"textContent":_vm._s(_vm.sLabel)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }